import React from 'react';
import { observer } from 'mobx-react-lite';
const Complete = ({ feature, remindText, other, loadingFailed, msg }) => {
    return (
        <div className="card wow fadeInDown mb-0">
            <div className="card-body tab-content">
                <div className="complete-info text-center mt-4">
                    {loadingFailed ? (
                        <div>
                            <p className="fs-2">
                                <i className="bi bi-exclamation-triangle-fill text-danger"></i>
                            </p>
                            <p className="fs-5">
                                <strong>{msg}</strong>
                            </p>
                        </div>
                    ) : (
                        <div>
                            <div className="success-info mb-4">
                                <i className="bi bi-check-circle-fill"></i>
                                <h2>申請完成</h2>
                            </div>
                            <p>
                                您已完成{other}
                                {feature}申請，審核中。
                            </p>
                            <p>{remindText}</p>
                        </div>
                    )}
                    <span className="path-info red rounded-pill  py-2 px-3">
                        {other}
                        {feature}結果請至帳務查詢
                        <i className="bi bi-chevron-right"></i> {feature}
                        查詢查看。
                    </span>
                </div>
            </div>
        </div>
    );
};

export default observer(Complete);
